module.exports = __webpack_public_path__ + "static/media/testimonialport2.9850b62f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonialport2.jpg
// module id = 466
// module chunks = 0